export const ARTICLE_PARENT_INFO_CLASSNAMES = {
  quotationMarks: `before:absolute before:top-0 before:left-0 before:content-['"'] after:absolute after:top-0 after:right-0 after:content-['"']`,
};
